var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudAlt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7064 7.72247C12.9674 5.55718 10.9155 4 8.5 4C5.46243 4 3 6.46243 3 9.5C3 10.4168 3.22431 11.2812 3.62104 12.0413C2.63045 12.8668 2 14.1098 2 15.5C2 17.9853 4.01472 20 6.5 20H17.5C19.9853 20 22 17.9853 22 15.5C22 13.9124 21.1779 12.5168 19.9361 11.7158C19.9781 11.4836 20 11.2443 20 11C20 8.79086 18.2091 7 16 7C15.1467 7 14.3558 7.26719 13.7064 7.72247Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudAlt2);
export default __webpack_public_path__ + "static/media/cloud-alt-2.8a3687ce7c2b47c5062e60cf3ccbce90.svg";
export { ForwardRef as ReactComponent };